export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Final (2)_06.eb27435e.jpg";